import {chunk, partialRight} from "lodash";

class PromiseDecorator {

    public static $inject: string[] = ["$provide"];

    constructor($provide) {
        $provide.decorator("$q", ["$delegate", $delegate => {
            const defer = $delegate.defer;
            const all = $delegate.all;
            const resolve = $delegate.resolve;

            const series = (array, fn) => {
                const deferred = defer();
                const results = [];

                array.reduce(
                    (previousPromise, entry) => {
                        return previousPromise.then(res => {
                            results.push(res);
                            return fn(entry);
                        });
                    },
                    $delegate.when(true)
                ).then(finalResult => {
                    // insert final promise results
                    results.push(finalResult);

                    // remove first promise ("true") from results
                    results.shift();

                    return deferred.resolve(results);
                }).catch(error => {
                    return deferred.reject(error);
                });

                return deferred.promise;
            };

            const applyAsync = (array, fn) => {
                const promises = [];
                array.forEach(data => {
                    promises.push(fn(data));
                });

                return all(promises);
            };

            const seriesChunks = (datas: any[], chunkSize, fn) => {
                return series(
                    chunk(datas, chunkSize),
                    partialRight(applyAsync, fn)
                ).then((results: any[]) => {
                    const mergedResult = results.reduce(
                        (a: any[], b: any[]) => {
                            return a.concat(b);
                        },
                        []
                    );
                    return resolve(mergedResult);
                });
            };

            $delegate.series = series;
            $delegate.seriesChunks = seriesChunks;
            $delegate.applyAsync = applyAsync;

            return $delegate;
      }]);
    }
}

angular
    .module("thor.core.promise.decorator", [])
    .config(PromiseDecorator);
